import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react'
import { getDateDaysAgo, showCurrency } from './Dashboard';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { Box } from '@material-ui/core';
import { getClassName } from '../demat/Holdings';
import _uniqueId from 'lodash/uniqueId';

const columns = [
  { field: 'tradeStrategy', headerName: 'Trade Strategy', width: 120 },
  { field: 'symbol', headerName: 'Symbol', width: 140 },
  { field: 'price', headerName: 'Alert Price', width: 120, type: 'number' },
  { field: 'ltp', headerName: 'LTP', width: 120, type: 'number' },
  {
    field: 'pnlAmount',
    headerName: 'P&L (₹)',
    width: 120,
    type: 'number',
    valueFormatter: value => showCurrency(value?.value, false)
  },
  { field: 'pnlPercentage', headerName: 'P&L %', width: 140, type: 'number' },
  {
    field: 'alertTs',
    headerName: 'Triggered at',
    width: 160,
    type: 'datetime',
  },
];


export const LatestAlerts = ({ user, fromDate, setFromDate, latestAlerts, isLoading }) => {
  const isUserLoggedIn = Object.keys(user).length > 0

  const handleDateChange = e => {
    const val = e?.target?.value
    setFromDate(val);
  }

  return (
    <Box
      sx={{
        '& .profit': {
          color: 'green',
        },
        '& .loss': {
          color: 'red',
        },
        '& .negative': {
          backgroundColor: 'rgba(157, 255, 118, 0.49)',
          color: '#1a3e72',
          fontWeight: '600',
        },
        '& .positive': {
          backgroundColor: '#d47483',
          color: '#1a3e72',
          fontWeight: '600',
        },
      }}
    >
      <DataGrid
        loading={isLoading}
        slots={{
          toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
            <Typography variant='h5' align='center'>Latest Alerts</Typography>
            {isUserLoggedIn &&
              <><Grid item display='flex' alignItems='center'>
                <Grid item>
                  <Typography>View alerts from:</Typography>
                </Grid>
                <Grid item>
                  <input type='date' value={fromDate} onChange={handleDateChange} />
                </Grid>
              </Grid>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
                <GridToolbarQuickFilter />
              </>
            }
          </GridToolbarContainer>
        }}
        columns={columns}
        rows={latestAlerts || []}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 30, 40]}
        autoHeight={true}
        getRowId={(row) => row?.id}
        getCellClassName={(params) => {
          if (params?.colDef?.type != 'number') return ''
          return getClassName(params, params?.field)
        }}
      />
    </Box>
  )
}
